<template>
  <span
    v-if="disableTransitions"
    :class="containerKls"
    :style="{ backgroundColor: color }"
    @click="handleClick"
  >
    <span :class="ns.e('content')">
      <slot />
    </span>
    <button
      v-if="closable"
      :aria-label="t('el.tag.close')"
      :class="ns.e('close')"
      type="button"
      @click.stop="handleClose"
    >
      <el-icon>
        <Close />
      </el-icon>
    </button>
  </span>
  <transition
    v-else
    :name="`${ns.namespace.value}-zoom-in-center`"
    appear
    @vue:mounted="handleVNodeMounted"
  >
    <span
      :class="containerKls"
      :style="{ backgroundColor: color }"
      @click="handleClick"
    >
      <span :class="ns.e('content')">
        <slot />
      </span>
      <button
        v-if="closable"
        :aria-label="t('el.tag.close')"
        :class="ns.e('close')"
        type="button"
        @click.stop="handleClose"
      >
        <el-icon>
          <Close />
        </el-icon>
      </button>
    </span>
  </transition>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import ElIcon from '@element-plus/components/icon'
import { Close } from '@element-plus/icons-vue'
import { useLocale, useNamespace } from '@element-plus/hooks'
import { useFormSize } from '@element-plus/components/form'
import { tagEmits } from './tag'

import type { VNode } from 'vue'
import type { TagProps } from './tag'

defineOptions({
  name: 'ElTag',
})
const props = withDefaults(defineProps<TagProps>(), {
  type: 'primary',
  effect: 'light',
})
const emit = defineEmits(tagEmits)

const tagSize = useFormSize()
const { t } = useLocale()
const ns = useNamespace('tag')
const containerKls = computed(() => {
  const { type, hit, effect, closable, round } = props
  return [
    ns.b(),
    ns.is('closable', closable),
    ns.m(type || 'primary'),
    ns.m(tagSize.value),
    ns.m(effect),
    ns.is('hit', hit),
    ns.is('round', round),
  ]
})

// methods
const handleClose = (event: MouseEvent) => {
  emit('close', event)
}

const handleClick = (event: MouseEvent) => {
  emit('click', event)
}

const handleVNodeMounted = (vnode: VNode) => {
  // @ts-ignore
  if (vnode?.component?.subTree?.component?.bum) {
    // @ts-ignore
    vnode.component.subTree.component.bum = null
  }
}
</script>
